
currentSlide = 0;

slideWrapper = document.getElementById('slideWrapper');
if (slideWrapper) {
    slides = slideWrapper.querySelectorAll('.slide');
    totalSlides = slides.length;
}

function slideTo(index) {
    if (index >= 0 && index < totalSlides) {
        // fade transition
        $('#slideWrapper .slide').removeClass('active');
        $('#slideWrapper .slide').eq(index).addClass('active');
        currentSlide = index;
    }
}

function slideToNext() {
    if (currentSlide < totalSlides - 1) {
        currentSlide++;
        $('#slideWrapper').css('transform', 'translateX(-' + (100 * currentSlide) + '%)');
    }
}
function closeModal(url) {
    $('#pinform').modal_close();
    $('#securityContentlink').click();
    window.location.href = url.attr('href');
  
}
function slideToPrevious() {
    if (currentSlide > 0) {
        currentSlide--;
        $('#slideWrapper').css('transform', 'translateX(-' + (100 * currentSlide) + '%)');

        // reset logic
        $("#pinConfirmForm").trigger('reset');
        $('.pin-input').removeClass('error');
        $('#errorMessage').hide();

        if (currentSlide === 0) {
            trustDeviceCheckbox = document.getElementById('trustDeviceCheckbox');
            if (trustDeviceCheckbox) {
                trustDeviceCheckbox.checked = false;
            }
        }
    }
}




trustDeviceCheckbox = document.getElementById('trustDeviceCheckbox');
if (trustDeviceCheckbox) {
    trustDeviceCheckbox.addEventListener('change', function () {
        if (this.checked) {
            setTimeout(function () {
                slideToNext();
            }, 300);
        }
    });
}

// "skip" or "back" buttons
function skipToSlide(index) {
    slideTo(index);
}
function resetform() {
    $('form').each(function () {
        this.reset();
    });
    
    $('[data-form="1"]').prop('disabled', true);
    $('.error-message').hide();
}
function checkForSubmit(selector , button) {
    allFilled = true;
    
    selector.each(function () {
        if (!$(this).val()) {
            allFilled = false;
            return false; 
        }
    });

    button.prop('disabled', !allFilled);
}
// pin script
$(document).ready(function () {
       // Select the input content on focus (single click) 
   otpinputs = document.querySelectorAll(".pin-input , .otp-input");
   otpinputs.forEach(function (input, index) {        
       input.addEventListener("focus", function (e) {
           e.target.select();
       });
     
   })
    // Toggle PIN visibility
    $('[id*="togglePin"]').on('click', function () {
        f = $(this).closest('form');
        var pinInputs = f.find('[data-group="pin"]');
        var eyeIcon = f.find('[id*="eyeIconPin"]');

        if (pinInputs.first().attr('type') === 'password') {
            pinInputs.attr('type', 'text');
            eyeIcon.html('<i class="icon-hide"></i>');
        } else {
            pinInputs.attr('type', 'password');
            eyeIcon.html('<i class="icon-eye"></i>');
        }
    });

    // Toggle Confirm PIN visibility
    $('[id*="toggleConfirm"]').on('click', function () {
        f = $(this).closest('form');
        var confirmInputs = f.find('[data-group="confirm"]');
        var eyeIcon = f.find('[id*="eyeIconConfirm"]');

        if (confirmInputs.first().attr('type') === 'password') {
            confirmInputs.attr('type', 'text');
            eyeIcon.html('<i class="icon-hide"></i>');
        } else {
            confirmInputs.attr('type', 'password');
            eyeIcon.html('<i class="icon-eye"></i>');
        }
    });

    // Handle input for PIN digits
    $('.pin-input').on('input', function () {
        var value = $(this).val();
        fo = $(this).closest('form').attr('class');
        f = $('form.' + fo.split(/\s+/).join('.'));
        // Only allow digits
        if (!/^\d$/.test(value) && value !== '') {
            $(this).val('');
            return;
        }

        // Auto-focus next input
        if (value && $(this).data('index') < 3) {
            var group = $(this).data('group');
            var nextIndex = $(this).data('index') + 1;
            var nextInput = $('[data-group="' + group + '"][data-index="' + nextIndex + '"]');
            nextInput.focus();
        }

        else if (value && $(this).data('index') === 3 && $(this).data('group') === 'pin' && $(this).closest('.form-group.pin-security').length > 0) {
            // When reaching the last pin input, jump to first confirm input
            var firstConfirmInput = $('[data-group="confirm"][data-index="0"]');
            firstConfirmInput.focus();
        }
        // display button pin

        // Check PIN match in real-time
        checkPinMatch(f);
    });
    $('.pinform [data-group="pin"]').on('input', function () {
        checkForSubmit($('.pinform [data-group="pin"]') , $('.pull-right[data-form="1"]'))        
    });
   
    // For the PIN confirmation input
    // $('[data-group="confirm"]').on('input', function () {     
    //     // f = $(this).closest('form').attr('class');
    //     // formEl = $('form.' + f.split(/\s+/).join('.'));
    //     checkForSubmit($('.pinform [data-group="confirm"]') , $('.pull-right[data-form="2"]'))
    //     // checkPinMatch($(this).closest('form'));
       
    // });
    // Handle backspace f
    $('.pin-input').on('keydown', function (e) {
        if (e.key === 'Backspace' && !$(this).val() && $(this).data('index') > 0) {
            var group = $(this).data('group');
            var prevIndex = $(this).data('index') - 1;
            var prevInput = $('[data-group="' + group + '"][data-index="' + prevIndex + '"]');
            prevInput.focus();
        } else if (e.key === 'Backspace' && !$(this).val() && $(this).data('index') === 0 && $(this).data('group') === 'confirm' && $(this).closest('.form-group.pin-security').length > 0) {
            // When on first confirm input and backspacing, go to last pin input
            var lastPinInput = $('[data-group="pin"][data-index="3"]');
            lastPinInput.focus();
        }
    });

    // Function to check PIN match
    function checkPinMatch(f) {
        var pin = '';
        var confirmPin = '';
        // Get PIN values
        f.find('[data-group="pin"]').each(function () {
            pin += $(this).val();
        });

        f.find('[data-group="confirm"]').each(function () {
            confirmPin += $(this).val();
        });

        // Clear previous states
        f.find('.pin-input').removeClass('error success');
        f.find('#errorMessage').hide();
        f.find('#successMessage').text('');

        //  check  confirm PIN 
        if (confirmPin.length == 4) {
            // Check if confirm PIN matches the original PIN up to its length
            var isMatching = confirmPin === pin.substring(0, confirmPin.length);

            if (!isMatching) {
                f.find('[data-group="confirm"]').addClass('error');
                f.find('#errorMessage').show().text(COMMON_LANG.PIN.PINMISMATCHERROR);
                $('.pull-right[data-form="2"]').prop('disabled', true);    
               
            } else if (confirmPin.length === 4 && pin.length === 4) {
                f.find('[data-group="confirm"]').addClass('success');
                f.find('#successMessage').text('PIN confirmed successfully!');
                $('.pull-right[data-form="2"]').prop('disabled', false);  
            }
        }
    }

});



// next slide if pin preffilles
$('.pin-input').on('keyup', function (e) {
    // if (e.key === 'Backspace') {
    f = $(this).closest('form').attr('class');
    formEl = $('form.' + f.split(/\s+/).join('.'));
    checkPinCompletion(formEl);
    // }
});
function checkPinCompletion(f) {
    var pin = '';
    var confirmPin = '';


    // Get PIN values from current slide
    // if (currentSlide === 1 || currentSlide == undefined) {
    // Second slide (PIN entry)
    f.find('[data-group="pin"]').each(function () {
        pin += $(this).val();
    });
    f.find('[name="pin"]').val(pin);
    // Enable/disable continue button based on PIN completion
    var continueBtn = $('.slide:nth-child(2) .btn-p ');
    if (pin.length === 4) {

        continueBtn.removeAttr('disabled');

    } else {
        continueBtn.prop('disabled', true);

    }
    // if (scope == 'dashbord') {

    f.find('[data-group="confirm"]').each(function () {

        confirmPin += $(this).val();

    });
    f.find('[name="pin_confirmation"]').val(confirmPin);
    if (confirmPin.length === 4 && $('.pin-input.error').length == 0) {
        f.find('.verificationQuickLogin').removeAttr('disabled');

    } else {
        f.find('.verificationQuickLogin').attr('disabled', true);

    }

}
$('.returnToPin , .edit_bt ').on('click', function (e) {
    e.preventDefault();
})

// skip request
$('[class*="_trusted_device"]').on('click', function (e) {
    e.preventDefault();
    form = $(this).closest('form');
    data = form.serialize();
    obj = $(this);
    if (obj.hasClass('send_pin_trusted_device')) {
        pin = "", confirmPin = "";
        $('[data-group="pin"]').each(function () {
            pin += $(this).val();
        });
        $('[data-group="confirm"]').each(function () {
            confirmPin += $(this).val();
        });
        data += '&pin=' + encodeURIComponent(pin) + '&pin_confirmation=' + encodeURIComponent(confirmPin);
    }
    $.ajax(new $.ajax_prototype(
        {
            'type': 'POST',
            'url': form.attr('action'),
            'data': data,
            'beforeSend': function () {
                obj.find('.loading').show();
                obj.find('.submitText').hide();
                form.find('#errorMessage').hide();
                $('.error-message').hide();
            },
            'success': function (data) {                
                
                if (data.success) {
                    $.alertHandler('', data.msg, alert_box_success);
                    if (data.data.result.action == 'skip') $('#pinform').modal_close();
                    if (data.data.hasOwnProperty('action') && (data.data.action == 'setAuthProvider') || data.data.action == 'addTrustedDevice') {
                        action = data.data.result.action;
                        if (action == 'delete' && data.data.result.auth_provider == 'quickLogin') {
                            slideTo(6);
                        } else {  slideTo(4) };           
                      
                    }                    
            
                   
                } else {
                    $('form').each(function () {
                        this.reset();
                    });
                    if(! (data.data.hasOwnProperty('identity_vetting_required') && data.data.identity_vetting_required))
                    $.alertHandler('', data.msg, alert_box_failure);
                    if (data.code == error_codes.validation_error && data.data.hasOwnProperty('pin') || data.code == error_codes.token_error) {
                        if(data.code == error_codes.validation_error && data.data.hasOwnProperty('pin'))
                        $('.error-message').show().text(data.data.pin);
                        slideTo(2);
                        $('[data-form="1"] , [data-form="2"] ').prop('disabled', true);
                    }
                    if (data.code == error_codes.token_error ) {
                        location.reload();
                        return
                    }
                }
                checkForIdentityVetting(data)                
                // applyActionsinProfiles(data)

            },
            'complete': function () {
                obj.find('.loading').hide();
                obj.find('.submitText').show();
            }

        }
    ));
})
